import { Modal } from '@mantine/core';
import { Healthcard, Patient, Payor } from 'interfaces';
import { PatientPaymentHistoryTable } from './PatientPaymentHistoryTable';

interface ClaimPatientPaymentHistoryModalProps {
  patientID: string;
  payors: Payor[];
  patient?: Patient;
  healthcard?: Healthcard | null;
  open: boolean;
  onClose: () => void;
}

export const ClaimPatientPaymentHistoryModal: React.FC<
  ClaimPatientPaymentHistoryModalProps
> = ({ patientID, payors, patient, healthcard, open, onClose }) => {
  return (
    <Modal
      opened={open}
      onClose={onClose}
      fullScreen
      h={'100%'}
      closeOnEscape={true}
      closeOnClickOutside={false}
    >
      <PatientPaymentHistoryTable
        patientID={patientID}
        payors={payors}
        patient={patient}
        healthcard={healthcard}
      />
    </Modal>
  );
};
